import {
  AdminInput,
  Button,
  Modal,
  PropsModal,
  SuccessToast,
  VDriveDeliveryEntity,
  updateInternalNotes,
  reportError,
} from '@vgrubs/components';
import { VDriveDeliveryInternalNoteEntity } from 'components/src/types/deliveries.types';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export const DeliveryInternalNotesModal = ({
  modalIsOpen,
  closeModal,
  setLoading,
  setData,
  data,
}: PropsModal & {
  modalIsOpen: boolean;
  setData: Dispatch<SetStateAction<VDriveDeliveryEntity | null>>;
  data: VDriveDeliveryEntity | null;
}) => {
  const [notes, setNotes] = useState('');

  useEffect(() => {
    if (data?.internalNotes?.[0] && modalIsOpen) {
      const first = data.internalNotes[0] as VDriveDeliveryInternalNoteEntity;
      setNotes(first?.note ?? '');
    }
  }, [modalIsOpen]);

  async function handleInternalNotes() {
    if (!data) return;
    try {
      setLoading?.(true);
      const res = await updateInternalNotes(data.id, notes);
      setData(res.data.data);
      SuccessToast(res.data.message);
      closeModal?.();
      setLoading?.(false);
    } catch (error) {
      reportError(error);
      setLoading?.(false);
    }
  }

  return (
    <Modal
      isOpen={modalIsOpen}
      closeModal={closeModal}
      logo={false}
      header="Internal Notes"
    >
      <AdminInput
        type="textarea"
        placeholder="Enter your notes here.."
        value={notes}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setNotes(e.target.value)
        }
      />

      <Button
        $selected
        $w="100%"
        $mt="40"
        onClick={() => handleInternalNotes()}
      >
        Save
      </Button>
    </Modal>
  );
};
